import React, { useState } from 'react';
import PageTitle from '../../../pagetitle/PageTitle';
import LeftBar from '../../../leftbar/LeftBar';
import CustomContent from '../../../customContent/CustomContent';
import
{
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  Card,
  CardText,
  CardTitle,
  Col,
  Nav,
  NavItem,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import { NavLink } from 'react-router-dom';
import { altin_sponsorluk, ana_sponsorluk, bronz_sponsorluk, gumus_sponsorluk, standart_katilim } from './sponsorluk_bilgileri_data';
import SponsorBilgiPaneli from './SponsorBilgiPaneli';

export default function SponsorlukBilgileri()
{
  const [activeTab, setActiveTab] = useState('1');

  const toggleTab = (tab) =>
  {
    if (activeTab !== tab)
    {
      setActiveTab(tab);
    }
  };

  return (
    <>
      <PageTitle name="Sponsorluk Bilgileri" />
      <div className="container">
        <Row>
          <Col md="9">
            <Nav tabs>
              <NavItem className="text-center m-1">
                <Button
                  className={`btn ${activeTab === '1' ? 'active' : ''}`}
                  onClick={() => toggleTab('1')}
                >
                  {ana_sponsorluk?.title}
                </Button>
              </NavItem>
              <NavItem className="text-center m-1">
                <Button
                  className={`btn ${activeTab === '2' ? 'active' : ''}`}
                  onClick={() => toggleTab('2')}
                >
                  {altin_sponsorluk?.title}
                </Button>
              </NavItem>
              <NavItem className="text-center m-1">
                <Button
                  className={`btn ${activeTab === '3' ? 'active' : ''}`}
                  onClick={() => toggleTab('3')}
                >
                  {gumus_sponsorluk?.title}
                </Button>
              </NavItem>
              <NavItem className="text-center m-1">
                <Button
                  className={`btn ${activeTab === '4' ? 'active' : ''}`}
                  onClick={() => toggleTab('4')}
                >
                  {bronz_sponsorluk?.title}
                </Button>
              </NavItem>
            </Nav>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                <SponsorBilgiPaneli sponsor={ana_sponsorluk}></SponsorBilgiPaneli>
              </TabPane>
              <TabPane tabId="2">
                <SponsorBilgiPaneli sponsor={altin_sponsorluk}></SponsorBilgiPaneli>
              </TabPane>
              <TabPane tabId="3">
                <SponsorBilgiPaneli sponsor={gumus_sponsorluk}></SponsorBilgiPaneli>
              </TabPane>
              <TabPane tabId="4">
                <SponsorBilgiPaneli sponsor={bronz_sponsorluk}></SponsorBilgiPaneli>
              </TabPane>
            </TabContent>
          </Col>
          <Col md="3">
            <LeftBar />
          </Col>
        </Row>

      </div>
    </>
  );
}
